import { css } from "@emotion/css";
import { Button, IconButton } from "@octopusdeploy/design-system-components";
import { space, text } from "@octopusdeploy/design-system-tokens";
import React from "react";
import useLocalStorage from "~/hooks/useLocalStorage";
export function LiveStatusFeedbackCallout() {
    const [dateDismissed, setDateDismissed] = useLocalStorage(`Octopus.Callout.LiveStatusFeedback.DateDismissed`, new Date("2022-01-1"));
    const [numberOfDismissals, setNumberOfDismissals] = useLocalStorage(`Octopus.Callout.LiveStatusFeedback.NumberOfDismissals`, 0);
    const onCloseCallout = () => {
        setDateDismissed(new Date());
        setNumberOfDismissals(numberOfDismissals + 1);
    };
    const isOutsideDismissalPeriod = isNowOutsideDismissalPeriod(dateDismissed, numberOfDismissals);
    if (isOutsideDismissalPeriod) {
        return (<div className={styles.wrapper}>
                <div className={styles.callout}>
                    <div className={styles.text}>Share your experience with Kubernetes Live Object Status</div>
                    <div className={styles.controls}>
                        <Button label={"Give Feedback"} onClick={() => { }} importance={"loud"}></Button>
                        <IconButton accessibleName={"Cancel"} icon={"XmarkIcon"} onClick={() => onCloseCallout()}></IconButton>
                    </div>
                </div>
            </div>);
    }
    return null;
}
function isNowOutsideDismissalPeriod(dateOfLastDismissal: Date, numberOfDismissals: number) {
    const today = new Date();
    const timeBombDate = new Date("2033-03-01");
    const dismissUntil = new Date(dateOfLastDismissal);
    dismissUntil.setDate(dismissUntil.getDate() + numberOfDismissals * 14);
    return today < timeBombDate && today > dismissUntil;
}
const styles = {
    wrapper: css({
        padding: "0 16px 16px 16px",
    }),
    callout: css({
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        padding: `${space[8]} ${space[16]}`,
        borderRadius: "6px",
        background: "linear-gradient(90deg, rgba(166, 131, 229, 0.15) 0%, rgba(135, 191, 236, 0.15) 100%)",
    }),
    text: css({
        font: text.body.regular.large,
    }),
    controls: css({
        display: "flex",
        flexDirection: "row",
        gap: space[8],
    }),
};
